<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row text-white" style="padding: 15px 110px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Checkout
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Checkout" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
      <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 600;">
          Checkout
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Checkout" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="row" style="margin: 75px 100px 50px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class ="col-12 col-md-5">
        <div class="col" style="margin-bottom: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
        <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
          Pesanan
        </div>
        <div class="row" v-for="data in list_data" style="padding: 15px;">
          <div class="col-12 col-md-3">
            <q-img :src="file_path+data.produk_file" style="width: 100px; border-radius: 5px;"/>
          </div>
          <div class="col-12 col-md-9" style="padding-left: 10px;">
            <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px;">
              {{data.produk_nama}}
            </div>
            <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px;">
              {{ data.kategori_uraian }}
            </div>
            <div class="row">
              <div class="col-6 col-md-6 produk-price1">Rp. {{data.produk_harga}} <span class="produk-price2"> Rp. {{data.produk_harga}}</span></div>
              <div class="col-3 col-md-3 text-center" style="padding-left: 10px;">
                X{{ data.kuantitas }}
              </div>
                <div class="col-3 col-md-3 text-right produk-price1">
                Rp. {{data.total}}
              </div>
            </div>
          </div>
        </div>
        <div v-if="list_data == 0" class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Manrope'; font-size: 16px; font-weight: 600; color: #2B2B2D;">
          <div class="col-6 col-md-6">
            Pesanan
          </div>
          <div class="col-6 col-md-6 text-right text-purple-12 text-weight-bolder">
            Rp. {{total_pesanan}}
          </div>
        </div>
        <div v-else class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Manrope'; font-size: 16px; font-weight: 600; color: #2B2B2D;">
          <div class="col-6 col-md-6">
            Total Pesanan
          </div>
          <div class="col-6 col-md-6 text-right text-purple-12 text-weight-bolder">
            Rp. {{total_pesanan}}
          </div>
        </div>
        </div>
        <div class="col" style="margin-bottom: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
        <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
          Catatan
        </div>
        <div class="col" style="padding: 15px;">
          <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; font-weight: lighter; color: #505050; margin-bottom: 10px;">
            Tambahkan catatan mengenai pesanan anda
          </div>
          <div class="row">
            <q-input
              v-model="form.catatan"
              outlined
              style="width: 100%;"
              color="purple-12"
              type="textarea"
            />
          </div>
        </div>
        </div>
        <div class="col" style="margin-bottom: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
        <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
          Metode Pembayaran
        </div>
        <div class="col" style="padding: 15px;">
          <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; font-weight: lighter; color: #505050; margin-bottom: 10px;">
            Silahkan pilih metode pembayaran yang ingin digunakan untuk pemesanan ini
          </div>
          <div class="row">
            <q-option-group
              :options="options"
              type="radio"
              color="purple-12"
              v-model="form.metode"
              style="color: #404040; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px;"
            />
          </div>
        </div>
        </div>
      </div>
      <div class="col-12 col-md-7">
        <div class="col" style="margin-bottom: 25px; margin-left: 25px; border: solid 1px #E9E9E9; border-radius: 5px;">
        <div class="row" style="padding: 15px 0; margin: 0 15px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 20px; font-weight: 600;">
          Informasi Pelanggan
        </div>
        <!-- <div class="col" style="padding: 15px;"> -->
          <div class="row" style="padding: 0 15px; margin-bottom: 15px;">
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                Nama Depan
              </div>
                <q-input class="input-font" v-model="nama" outlined placeholder="Nama Depan" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Nama Belakang
                </div>
                <q-input class="input-font" v-model="belakang" outlined placeholder="Nama Belakang" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Email
                </div>
                <q-input class="input-font" v-model="email" outlined placeholder="Email" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm">
                <div class="row input-label">
                  Nomor HP
                </div>
                <q-input class="input-font" v-model="hp" outlined placeholder="Nomor HP" type="number" color="purple-12" dense />
            </div>
            <div class="col-12 q-pa-sm">
                <div class="row input-label">
                  Alamat Pengiriman
                </div>
                <q-input class="input-font" v-model="alamat" outlined placeholder="Alamat Pengiriman" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Desa / Kelurahan
                </div>
              <q-select class="input-font" outlined v-model="des" :options="desa" color="purple-12" placeholder="Desa / Kelurahan" dense transition-show="scale" transition-hide="scale" />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Kode Pos
                </div>
                <q-input class="input-font" v-model="pos" outlined placeholder="Kode Pos" color="purple-12" dense />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Kecamatan
                </div>
                <q-select class="input-font" outlined v-model="kec" style="color: #C039FF;" :options="kecamatan" color="purple-12" placeholder="Kecamatan" dense transition-show="scale" transition-hide="scale" />
            </div>
            <div class="col-6 q-pa-sm">
              <div class="row input-label">
                  Kabupaten
                </div>
                <q-select class="input-font" outlined v-model="kab" :options="kabupaten" color="purple-12" placeholder="Kabupaten" dense transition-show="scale" transition-hide="scale" />
            </div>
          <!-- </div> -->
        </div>
        </div>
        <div class="col text-right" style="margin: 15px 0;">
            <q-btn no-caps color="purple-12" label="Buat Pesanan" @click="addData()" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
        </div>
      </div>
    </div>
    <div class="row" style="margin: 25px 20px 0;" v-if="$q.screen.lt.sm">
      <div class ="col-12">
        <div class="col" style="margin-bottom: 15px; border: solid 1px #E9E9E9; border-radius: 5px;">
        <div class="row" style="padding: 10px 0; margin: 0 10px 10px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px; font-weight: 600;">
          Pesanan
        </div>
        <div class="row" v-for="data in list_data" style="padding: 5px 10px;">
          <div class="col-3">
            <q-img :src="file_path+data.produk_file" style="width: 95px; height: 75px; border-radius: 5px;"/>
          </div>
          <div class="col-9" style="padding-left: 10px;">
            <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12.5px;">
              {{data.produk_nama}}
            </div>
            <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px;">
              {{ data.kategori_uraian }}
            </div>
            <div class="row">
              <div class="col-6 produk-price1-checkout">Rp. {{data.produk_harga}} <span class="produk-price2-checkout"> Rp. {{data.produk_harga}}</span></div>
              <div class="col-3 text-center" style="padding-left: 10px; font-size: 12.5px;">
                X{{ data.kuantitas }}
              </div>
                <div class="col-3 text-right produk-price1-checkout">
                Rp. {{data.total}}
              </div>
            </div>
          </div>
        </div>
        <div v-if="list_data == 0" class="row" style="padding: 10px 0; margin: 10 10px 0; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Manrope'; font-size: 13px; font-weight: 600; color: #2B2B2D;">
          <div class="col-6">
            Pesanan
          </div>
          <div class="col-6 text-right text-purple-12 text-weight-bolder">
            Rp. {{total_pesanan}}
          </div>
        </div>
        <div v-else class="row" style="padding: 10px 0; margin: 10px 10px 0; border-width: 1px; border-color: #E9E9E9; border-style: solid none none none; font-family: 'Manrope'; font-size: 13px; font-weight: 600; color: #2B2B2D;">
          <div class="col-6">
            Total Pesanan
          </div>
          <div class="col-6 text-right text-purple-12 text-weight-bolder">
            Rp. {{total_pesanan}}
          </div>
        </div>
        </div>
        <div class="col" style="margin-bottom: 15px; border: solid 1px #E9E9E9; border-radius: 5px;">
          <div class="row" style="padding: 10px 0; margin: 0 10px 10px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px; font-weight: 600;">
          Catatan
        </div>
        <div class="col" style="padding: 0 10px;">
          <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: lighter; color: #505050; margin-bottom: 10px;">
            Tambahkan catatan mengenai pesanan anda
          </div>
          <div class="row" style="margin-bottom: 10px;">
            <q-input
              v-model="form.catatan"
              outlined
              style="width: 100%;"
              color="purple-12"
              type="textarea"
            />
          </div>
        </div>
        </div>
        <div class="col" style="margin-bottom: 15px; border: solid 1px #E9E9E9; border-radius: 5px;">
          <div class="row" style="padding: 10px 0; margin: 0 10px 10px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px; font-weight: 600;">
          Metode Pembayaran
        </div>
        <div class="col" style="padding: 0 10px;">
          <div class="row" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: lighter; color: #505050; margin-bottom: 10px;">
            Silahkan pilih metode pembayaran yang ingin digunakan untuk pemesanan ini
          </div>
          <div class="row" style="margin-bottom: 10px;">
            <q-option-group
              :options="options"
              type="radio"
              color="purple-12"
              v-model="form.metode"
              style="color: #404040; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 12.5px;"
            />
          </div>
        </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col" style="border: solid 1px #E9E9E9; border-radius: 5px;">
          <div class="row" style="padding: 10px 0; margin: 0 10px 10px; border-width: 1px; border-color: #E9E9E9; border-style: none none solid none; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 15px; font-weight: 600;">
          Informasi Pelanggan
        </div>
        <!-- <div class="col" style="padding: 15px;"> -->
          <div class="row" style="padding: 0 10px; margin-bottom: 10px;">
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                Nama Depan
              </div>
                <q-input class="input-font" v-model="nama" outlined placeholder="Nama Depan" color="purple-12" dense />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Nama Belakang
                </div>
                <q-input class="input-font" style="font-size: 12.5px;" v-model="belakang" outlined placeholder="Nama Belakang" color="purple-12" dense />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Email
                </div>
                <q-input class="input-font" style="font-size: 12.5px;" v-model="email" outlined placeholder="Email" color="purple-12" dense />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
                <div class="row input-label-checkout">
                  Nomor HP
                </div>
                <q-input class="input-font" style="font-size: 12.5px;" v-model="hp" outlined placeholder="Nomor HP" type="number" color="purple-12" dense />
            </div>
            <div class="col-12 q-pr-xs q-pl-xs">
                <div class="row input-label-checkout">
                  Alamat Pengiriman
                </div>
                <q-input class="input-font" style="font-size: 12.5px;" v-model="alamat" outlined placeholder="Alamat Pengiriman" color="purple-12" dense />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Desa / Kelurahan
                </div>
              <q-select class="input-font" style="font-size: 12.5px;" outlined v-model="des" :options="desa" color="purple-12" placeholder="Desa / Kelurahan" dense transition-show="scale" transition-hide="scale" />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Kode Pos
                </div>
                <q-input class="input-font" style="font-size: 12.5px;" v-model="pos" outlined placeholder="Kode Pos" color="purple-12" dense />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Kecamatan
                </div>
                <q-select class="input-font" outlined v-model="kec" style="color: #C039FF; font-size: 12.5px;" :options="kecamatan" color="purple-12" placeholder="Kecamatan" dense transition-show="scale" transition-hide="scale" />
            </div>
            <div class="col-6 q-pr-xs q-pl-xs">
              <div class="row input-label-checkout">
                  Kabupaten
                </div>
                <q-select class="input-font" style="font-size: 12.5px;" outlined v-model="kab" :options="kabupaten" color="purple-12" placeholder="Kabupaten" dense transition-show="scale" transition-hide="scale" />
            </div>
          <!-- </div> -->
        </div>
        </div>
        <div class="col text-right" style="margin: 10px 0;">
            <q-btn no-caps color="purple-12" label="Buat Pesanan" @click="addData()" style="font-family: 'Manrope'; font-size: 12.5px; font-weight: bold;" />
        </div>
      </div>
    </div>
    <div style="margin: 0 100px 75px; padding-top: 75px; border-style: solid none none none; border-color: #E9E9E9; border-width: 1px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row" style="margin-bottom: 25px;">
            <div class="col-12 col-md-6 produk-title1">
                Produk Populer
                </div>
            <div class="col-12 col-md-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12">
                    <div class="produk-title2">Lihat Semua Produk</div>
                    <div class="produk-btn">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-md">
        <div class="col-12 col-md-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="275px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat">
                    {{data.kategori_uraian}}
                    </div>
                    <div style="padding-bottom: 15px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="1em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                    <div class="produk-price1">Rp. {{data.harga}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
    <div style="margin: 25px 20px; padding-top: 25px; border-style: solid none none none; border-color: #E9E9E9; border-width: 1px;" v-if="$q.screen.lt.sm">
      <div class="row" style="margin-bottom: 5px;">
            <div class="col-6 produk-title1-android">
                Produk Populer
                </div>
            <div class="col-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12" style="margin-top: -10px; margin-right: -15px;">
                    <div class="produk-title2-android">Lihat Semua Produk</div>
                    <div class="produk-btn-android">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-xs">
        <div class="col-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="100px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="xs"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="0.5em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div class="produk-price1-android">Rp. {{data.harga}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
  </div>
</template>

<script>

import { ref } from 'vue'
// import SearchView from '@/views/SearchView.vue'

export default {
  name: 'ProdukView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
      form : {
        id : '',
        catatan : '',
        metode : '',
        status : 'DIBUAT',
        produk : [],
      },
      counter: 1,
      tabs: ref('all'),
      current: ref(1),
      list_kategori : [{id : '12', nama : 'Cemilan'}, {id : '13', nama : 'Kerajinan Tangan'}, {id : '14', nama : 'Olahan Pangan'}, {id : '15', nama : 'Minuman'}, {id : '16', nama : 'Makanan'}, {id : '17', nama : 'Hasil Perkebunan'}],
      list_produk : [{id : '1', judul : 'Buah Nangka', harga : '40.000', diskon : '53.000'}, {id : '2', judul : 'Kursi Rotan', harga : '120.000', diskon : '150.000'}, {id : '3', judul : 'Nasi Goreng', harga : '20.000', diskon : '23.000'}],
      payment: ref(null),
      file_path: this.$store.state.url.URL_APP + "uploads/",
      options: [
        { label: 'Bayar Ditempat', value: 'bayar' },
        { label: 'Transfer Bank', value: 'transfer' }
      ],
      kec: ref(null),
      kecamatan: [
        'Angata', 'Andoolo', 'Tinanggea', 'Basala', 'Palangga'
      ],
      des: ref(null),
      desa: [
        'Angata', 'Andoolo', 'Tinanggea', 'Basala', 'Palangga'
      ],
      kab: ref(null),
      kabupaten: [
        'Konawe Selatan', 'Kendari', 'Konawe', 'Bombana', 'Konawe Kepulauan'
      ],
      list_data : [],
      produk_populer : [],
      total_pesanan : '',
    }
  },
  methods: {
    getView : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_KERANJANG  + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.form.produk = res_data.data;
              console.log(this.form.produk);
              // this.total_pesanan = res_data[0].data.total_pesanan;
              this.$store.commit("hideLoading");
              console.log(this.list_data);
      });
    },

    push_produk : function(id){
      this.$router.push('/produk_detail/'+id);
    },

    addData : function() {
        fetch(this.$store.state.url.URL_KERANJANG + "addPesanan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.form)
        })
        // .then(res => res.json())
        .then(res_data => {
          this.Notify('Pesanan Anda Telah Dibuat', 'purple-12', 'check_circle_outline');
          console.log(res_data);
          this.getView();
        });

        //  console.log(this.form.jenisPariwisata)



      },

      getProdukPopuler : function(){
      fetch(this.$store.state.url.URL_PRODUK  + "produkPopuler", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.produk_populer = res_data.data;
      });
    },

    getTotal : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_KERANJANG  + "total", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
            // console.log(res_data);
              this.total_pesanan = res_data.data[0].total_pesanan;
              // this.total_pesanan = res_data[0].data.total_pesanan;
              this.$store.commit("hideLoading");
              console.log(this.total_pesanan+"asfdsfsf");
      });
    },

    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

  },

  mounted() {
    this.getView();
    this.getTotal();
    this.getProdukPopuler();
  }
}
</script>
